export * from './config-utils';
export * from './config/form-allow-map';
export * from './config/priority';
export * from './const';
export * from './json-types';
export * from './live-update.types';
export * from './printable';
export * from './ts-types';
export * from './types/index';
export * from './utils';
export * from './validators';
//
export enum OrderByTrpc {
	ASC = 'asc',
	DESC = 'desc',
}

export interface OrderByTrpcDto {
	key: string;
	order: OrderByTrpc;
}
